import { useTheme } from "@mui/material";
import { statusKeys, statusItems } from "../trackPage/trackPageHelper";

interface TrackListChangeStatusConfirmationTitleProps {
    statusCode: string;
}

export const TrackListChangeStatusConfirmationTitle = ({
    statusCode
}: TrackListChangeStatusConfirmationTitleProps) => {

    const theme = useTheme();

    const statusItem = statusItems.find((si) => si.key === statusCode);
    const statusColour = statusCode === statusKeys.active ?
        theme.palette.success.main :
        theme.palette.warning.main;

    return (
        <>
            Change Status to
            <span style={{color:statusColour, fontWeight: 'bold'}}> {statusItem?.value}</span>
        </>
    )
}
